import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

import InputContainer from '../../FormField/styled/InputContainer';

export default styled.div`
  display: flex;
  flex-flow: column wrap;
  margin-bottom: 24px;

  > ${InputContainer} {
    display: block;
    margin-top: 16px;
  }

  ${media.moreThan('sm')`
    flex-flow: row wrap;
    justify-content: space-between;
    width: 70%;
    margin: 0 auto 24px auto;

    > ${InputContainer} {
      flex: 0 0 49%;

      &:last-child {
        flex: 0 0 100%;
      }
    }
  `};
`;
